<template>
  <div
    class="subpanel"
    :class="{ 'subpanel--tripwire': tripwire }"
    :style="{ '--subpanel-accent': accent }"
  >
    <div class="subpanel-head">
      <i v-if="icon" class="bi" :class="icon"></i>
      <span class="subpanel-label">{{ label }}</span>
      <span v-if="countText" class="subpanel-count">· {{ countText }}</span>
      <span v-if="tripwire" class="subpanel-modal-pill">{{ $t('controls.tripwire.pill') }}</span>
    </div>
    <div class="subpanel-body">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  label:     { type: String, required: true },
  countText: { type: String, default: '' },
  icon:      { type: String, default: '' },
  tripwire:  { type: Boolean, default: false },
  accent:    { type: String, default: 'var(--stora-accent, #004F6E)' },
})
</script>

<style scoped>
.subpanel {
  --subpanel-accent: var(--stora-accent, #004F6E);
  margin-top: 18px;
  padding: 14px 16px 16px;
  border: 1px solid #e5eaf0;
  border-left: 4px solid var(--subpanel-accent);
  border-radius: 12px;
  background: #fff;
}
.subpanel--tripwire {
  border-style: solid dashed dashed dashed;
  border-left-style: dashed;
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--subpanel-accent) 4%, #fff) 0, #fff 60%),
    #fff;
}
.subpanel-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.subpanel-head .bi { color: var(--subpanel-accent); font-size: 0.95rem; }
.subpanel-label { color: var(--subpanel-accent); }
.subpanel-count { color: #98a3ad; font-weight: 600; letter-spacing: 0.04em; }
.subpanel-modal-pill {
  margin-left: auto;
  padding: 2px 8px;
  font-size: 0.6rem;
  color: var(--subpanel-accent);
  background: color-mix(in srgb, var(--subpanel-accent) 10%, #fff);
  border: 1px dashed color-mix(in srgb, var(--subpanel-accent) 55%, #fff);
  border-radius: 999px;
  line-height: 1;
}
</style>
